// images frankfurt
import neosferOffice from '../../assets/images/locations/frankfurt/office.jpg';
import neosferRooftop from '../../assets/images/locations/frankfurt/neosfer-rooftop.jpg';
import neosferKitchen from '../../assets/images/locations/frankfurt/neosfer-kitchen.png';
// images prague
import nationalLibraryOfTech from '../../assets/images/locations/prague/NTK.jpg';
import facultyOfArchitecture from '../../assets/images/locations/prague/cvut.jpg';
import sara from '../../assets/images/locations/prague/sara.jpg';
// images sofia
import venue1 from '../../assets/images/locations/sofia/venue1.jpg';
import venue3 from '../../assets/images/locations/sofia/venue3.jpg';
import venue4 from '../../assets/images/locations/sofia/venue4.jpg';
// images lodz
import collabLodz from '../../assets/images/locations/lodz/CollabLdz.png';
import collabLodzChillout from '../../assets/images/locations/lodz/CollabLdz_chillout.png';
import collabLodzWorkplace from '../../assets/images/locations/lodz/CollabLdz_workplace.png';

export const locationInfoCardsData = [
    {
        country: 'Germany',
        info: [
            {
                imgSrc: neosferOffice,
                title: 'Use our modern and fully equipped office to work on your innovative ideas',
                subTitle: 'Unleash Your Creativity in a Cutting-Edge Workspace',
                description:
                    'Step into our modern and fully equipped office space, designed to inspire and support your innovative ideas. Experience a productive atmosphere where height adjustable tables and large screens empower you to bring your concepts to life. With a blend of functionality and aesthetics, our workspace sets the stage for collaboration.',
            },
            {
                imgSrc: neosferRooftop,
                title: 'Enjoy the Skyline of Frankfurt at our Rooftop',
                subTitle:
                    'Elevate Your Experience: Rooftop Delights and Cityscape Views',
                description:
                    'Indulge in the breathtaking skyline of Frankfurt from our vibrant rooftop venue. With an inviting ambiance and panoramic view, our rooftop provides the perfect setting to unwind, network, and create lasting memories while soaking up the vibrant spirit of the hackathon.',
            },
            {
                imgSrc: neosferKitchen,
                title: 'Network in our open space kitchen area',
                subTitle: 'Connect, Collaborate, and Culinary Delights',
                description:
                    'Step into our open space kitchen area, a hub of creativity and connection. Whether your sharing ideas, enjoying our delicous refreshments, or simply taking a moment of relax, our open space kitchen provides the perfect backdrop for networking and fostering collaboration among participants, fuelling the innovative spirit of the hackathon.',
            },
        ],
    },
    {
        country: 'Poland',
        info: [
            {
                imgSrc: collabLodzWorkplace,
                title: 'Code comfortably, innovate unbound',
                subTitle: 'Craft your ideas in comfortable surroundings',
                description:
                    "Join us at Textorial Park, a meticulously designed venue that offers a comfortable and conducive environment for nurturing your innovative ideas. With abundant workspace, you'll find the perfect setting to focus, brainstorm, and collaborate seamlessly. Relaxed atmosphere enhances creativity, so our venue is designed to help you achieve breakthroughs while feeling at ease.",
            },
            {
                imgSrc: collabLodzChillout,
                title: 'Have fun, innovate, network… and repeat!',
                subTitle: 'Where networking meets vibrant enjoyment',
                description:
                    'Immerse yourself in a space that not only fuels your coding sessions but also indulges your senses! Nestled in a lush green park, complete with food truck zones and relaxing areas, this venue strikes a perfect balance between coding intensity and refreshing downtime. Take breaks from your coding marathons to chill out, connect with participants, and exchange ideas.',
            },
            {
                imgSrc: collabLodz,
                title: 'Get inspired by the charm of Księży Młyn',
                subTitle:
                    "Let Lodz's post-industrial charm ignite your creativity",
                description:
                    'Embark on a captivating journey through time as you gaze out the window. Discover the enchanting area of Księży Młyn, a 19th-century factory-residential complex transformed into a top city must-see. Wander along cobbled streets, immersing yourself in the rich history of Łódź, and let the past spark your creative flames in a venue that bridges history and modernity.',
            },
        ],
    },
    {
        country: 'CzechRepublic',
        info: [
            {
                imgSrc: nationalLibraryOfTech,
                title: 'The National Library of Technology (NTK)',
                subTitle:
                    'The largest and the oldest library of science and technology literature in the Czech Republic, with a collection of over 1.5 million volumes.',
                description:
                    'Housed in a modern, ecological, award-winning building situated in the heart of the Dejvice engineering and technology campus. The National Library of Technology in Prague is not only a place to study and learn, but also a place to socialize and have fun! 🎉🧠',
            },
            {
                imgSrc: facultyOfArchitecture,
                title: 'Faculty of Information Technology (FIT) at Czech Technical University',
                subTitle:
                    'Venue shared with the Faculty of Architecture, CTU, which gives the spaces a creative touch',
                description:
                    'The monolithic concrete energetically sustainable, self-breathing building from 2011. The heart of the faculty. The place where students are taught  how to think, not just how to type automatically. How cool is that? 😎',
            },
            {
                imgSrc: sara,
                title: 'Cloud Civilisations, Honest, and Optimised Systems (CCHAOS)',
                subTitle:
                    'Local partner group with Sara Polak as Forbes 30 Under 30, and our Collabothon moderator',
                description:
                    "An interdisciplinary team of IT, AI and social science experts. The enabler of international 'cloud' collabothon that shows the super cooperation of the academic and industrial spheres.",
            },
        ],
    },
    {
        country: 'Bulgaria',
        info: [
            {
                imgSrc: venue1,
                title: 'Launching Creativity at Joy Station Sofia - Where Innovation Takes Flight',
                subTitle:
                    'An Inspiring Space-like venue Designed to Invent and experiment',
                description:
                    "Step into a realm of unparalleled creativity at Joy Station Sofia's Collabothon. With open spaces, captivating lighting, and an ambiance that ignites the imagination, this unique venue is the perfect breeding ground for groundbreaking ideas.",
            },
            {
                imgSrc: venue3,
                title: 'Game On, Change Makers: Sofia Blends Networking and Entertainment',
                subTitle:
                    'Unwind, Connect, Code and Conquer Challenges Amidst Cutting-Edge Fun',
                description:
                    'Changing the world is no small task, but here we believe in balancing hard work with rejuvenating play. Immerse yourself in cutting-edge bowling stations and an array of captivating games. Forge new connections, fuel your creativity, and unwind while challenging your newfound friends.',
            },
            {
                imgSrc: venue4,
                title: 'Culinary Fuel for Brilliant Minds. Energize, Network & Revitalize',
                subTitle:
                    'Delicious Delights, Refreshing Breaks, and Brain-Boosting Nourishment',
                description:
                    'Energize yourself, network with like-minded innovators, and get ready to overcome obstacles with a revitalized spirit. Indulge in a selection of culinary delights, refreshing breaks, and brain-boosting nourishment.',
            },
        ],
    },
];
